<template>
  <Layout>
    <Aguarde :show="showAguarde"></Aguarde>
    <PageHeader :title="title" :items="items"/>
    <div v-if="empresa && empresa.eco_codigo" class="row">
      <div class="col-12">
        <div class="card">
          <b-tabs v-model="tab_index" content-class="crypto-buy-sell-nav-content" nav-class="nav-tabs-custom">
            <b-tab v-if="pessoaFisica" title="Pessoa Física">
              <pessoa-fisica-detalhe-dados v-if="tab_index===0"
                                           :eco_codigo="empresa.eco_codigo"
                                           :list-classe-profissional="tab_selecoes.classe_profissional"
                                           :list-escolaridade="tab_selecoes.escolaridade"
                                           :list-estado-civil="tab_selecoes.estado_civil"
                                           :list-sexo="tab_selecoes.sexo"
                                           :natureza_juridica="tab_selecoes.natureza_juridica">
              </pessoa-fisica-detalhe-dados>
            </b-tab>
            <b-tab v-else title="Empresa">
              <empresa-detalhe-dados v-if="tab_index===0" :eco_codigo="empresa.eco_codigo"
                                     :natureza_juridica="tab_selecoes.natureza_juridica"></empresa-detalhe-dados>
            </b-tab>
            <b-tab title="Fiscal" :disabled="pessoaFisica">
              <empresa-detalhe-fiscais v-if="tab_index===1" :eco_codigo="empresa.eco_codigo"></empresa-detalhe-fiscais>
            </b-tab>
            <b-tab title="Contato" :disabled="pessoaFisica">
              <empresa-detalhe-contato v-if="tab_index===2" :tipo_telefone="tab_selecoes.telefone_tipo"
                                       :eco_codigo="empresa.eco_codigo"></empresa-detalhe-contato>
            </b-tab>
            <b-tab title="Usuários">
              <empresa-detalhe-usuarios v-if="tab_index===3"
                                        :eco_codigo="empresa.eco_codigo"></empresa-detalhe-usuarios>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import EmpresaDetalheDados from "@/router/views/admin/components/empresas/empresa-detalhe-dados"
import PessoaFisicaDetalheDados from "@/router/views/admin/components/empresas/pessoa-fisica-detalhe-dados"
import EmpresaDetalheFiscais from "@/router/views/admin/components/empresas/empresa-detalhe-fiscais"
import EmpresaDetalheContato from "@/router/views/admin/components/empresas/empresa-detalhe-contato"
import EmpresaDetalheUsuarios from "@/router/views/admin/components/empresas/empresa-detalhe-usuarios"
import {getTabSelecoes} from "@/api/geral/helps";
import {getDadosEmpresa} from "@/api/admin/gestao/empresas";
import {notifyErro} from "@/helps/notificacao";

export default {
  page: {
    title: "Guias",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Aguarde,
    PageHeader,
    EmpresaDetalheDados,
    PessoaFisicaDetalheDados,
    EmpresaDetalheFiscais,
    EmpresaDetalheContato,
    EmpresaDetalheUsuarios
  },
  created() {
    if (this.$route.params.eco_codigo) {
      this.GetEmpresa();
    }
  },
  data() {
    return {
      title: "Detalhes da Empresa",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Empresas Autorizadas',
          href: '/admin/pessoas/autorizadas',
        },
        {
          text: 'Detalhes da Empresa',
          active: true,
        },
      ],
      tab_index: 0,
      showAguarde: false,
      pessoaFisica: false,
      empresa: {
        eco_codigo: null
      },
      tab_selecoes: {
        natureza_juridica: [],
        telefone_tipo: [],
        sexo: [],
        estado_civil: [],
        nacionalidade: [],
        escolaridade: [],
        classe_profissional: []
      },
    };
  },
  methods: {
    tabSelecoes() {
      let tipo = (this.pessoaFisica) ? 1 : 2;
      getTabSelecoes(tipo).then(response => {
        this.tab_selecoes.natureza_juridica = response.dados.natureza_juridica;
        this.tab_selecoes.sexo = response.dados.sexo;
        this.tab_selecoes.estado_civil = response.dados.estado_civil;
        this.tab_selecoes.nacionalidade = response.dados.nacionalidade;
        this.tab_selecoes.escolaridade = response.dados.escolaridade;
        this.tab_selecoes.classe_profissional = response.dados.classe_profissional;
        this.tab_selecoes.telefone_tipo = response.dados.telefone_tipo;
      }).catch(error => {
        console.log(error);
      })
    },
    GetEmpresa() {
      this.showAguarde = true;
      getDadosEmpresa(this.$route.params.eco_codigo).then(response => {
        if (response.status) {
          this.empresa = response.dados;
          this.empresa.eco_codigo = parseInt(this.empresa.eco_codigo);
          this.pessoaFisica = (this.empresa.pes_cpfcnpj.length === 11)
          this.tabSelecoes();
        } else {
          notifyErro("DattaNFSe", "Erro ao localizar empresa")
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.showAguarde = false;
      })
    },
  }
};
</script>


